import React from 'react'
import { TextProgressContainer } from './style'
import Text, { TextScale } from 'particles/Text'
import { theme } from 'theme'
import Box from '@mui/material/Box'

interface TextProgressProps {
    completedSlot: string
    completedSlotTextType?: TextScale
    totalSlot: string
    totalSlotTextType?: TextScale
}

const TextProgress: React.FC<TextProgressProps> = ({
    completedSlot,
    completedSlotTextType = 'bodyS500',
    totalSlot,
    totalSlotTextType = 'bodyS400',
}) => {
    return (
        <TextProgressContainer>
            <Text scale={completedSlotTextType} color="primary">
                {completedSlot}
            </Text>
            <Box marginLeft={theme.newSpacing.xxxxs} />
            <Text scale={totalSlotTextType} color="primary">
                {'/ ' + totalSlot}
            </Text>
        </TextProgressContainer>
    )
}

export default TextProgress
